import { languages } from "../locale"
import { app } from "../app";
import { Link, useParams } from "react-router-dom";
import { ChevronRight } from "./icons";
import { getLocaleByZendesk } from "../helpers";

export interface CardsProps {
  title: string;
  subtitle: string;
  iconName: string;
  href: string | (() => void);
  passHref?: boolean;
  target?: "_blank" | "_self" | "_parent" | "_top";
  color: string;
}

export interface HomePageCards {
  cards: CardsProps[];
}

function Cards({
  title,
  subtitle,
  href,
  target,
  color,
}: CardsProps) {
  const isRTL = languages[app.locale]?.rtl;

  const cardStyle = {
    backgroundColor: color,
    transition: 'background-color 0.3s, color 0.3s',
    border: `1px solid ${color}`,
  }

  const cardContent = (
    <div style={cardStyle} className={`home-page-card`}>
      <h3 className={`card-title font-inter !leading-8 ${isRTL ? 'text-right' : 'text-left'}`} style={{ direction: isRTL ? "rtl" : "ltr" }}>
        {title}
      </h3>
      <div className={`min-w-[34px]`} style={{ transform: isRTL ? 'rotate(180deg)' : '' }}>
        <ChevronRight />
      </div>
    </div>
  );
  

  return typeof href === "string" ? (
    <Link to={href} tabIndex={0} target={target}>
      {cardContent}
    </Link>
  ) : (
    <div
      className="card-wrapper"
      role="button"
      aria-label={title}
      tabIndex={0}
      onClick={href}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          href();
        }
      }}
    >
      {cardContent}
    </div>
  );
}

export default function HomePageCards({
  cards,
}: HomePageCards) {
  let { locale } = useParams()
  const languageSelected = locale ? getLocaleByZendesk(locale.toLowerCase()) : (localStorage.getItem('preferredLanguage') ? localStorage.getItem('preferredLanguage') : app.locale)
  const isRTL = languages[languageSelected]?.rtl
  return (
    <div className={`card-list-wrapper ${isRTL ? 'rtl' : 'ltr'}`}>
      {cards.map((c, index) => (
        <Cards key={`${c.title}-${index}`} {...c} />
      ))}
    </div>
  );
}
